module.exports = __webpack_public_path__ + "static/media/iconEditWhite.4321580d.svg";